import { useQuery } from "@tanstack/react-query";

export interface EntitlementLimits {
  memoryWindowMessages: number | null;
  retainedThreads: number | null;
  dailyMessages: number | null;
  advancedResonance: boolean;
  dataExport: boolean;
}

export interface EntitlementStatus {
  tier: "free" | "plus" | "pro";
  founding: boolean;
  activeUntil: string | null;
  limits: EntitlementLimits;
  usedToday: number;
  credits: number;
  signedIn: boolean;
}

/** Current caller's tier, limits, and today's usage — see GET /api/billing/status. */
export function useEntitlement() {
  return useQuery<EntitlementStatus>({ queryKey: ["/api/billing/status"] });
}
